<template id="sitesGoogleMapTmpl" >
  <div>
      

  <v-card v-if="sitesList != null && sitesList != []" class="elevation-8">
		<GmapMap
			:center=startCenter
			:zoom="6"
			map-type-id="terrain"
			style="width: 100%; height: 500px"
			:options="options"
		>
		<GmapMarker
			:key="index"
			v-for="(m, index) in markers"
			:position="m.position"
			:clickable="true"
			:draggable="false" 
			:icon=m.icon 
			@click="doSelectSite(m.siteObj)"
		/>
		</GmapMap>

    <!-- DIALOG LISTA MAPPE -->
    <ct-maps-list ref="dialogMapsList" :siteObj="siteSelectedObj"></ct-maps-list>

  </v-card>
  <div v-else>{{$t('err.noSitesFound')}}</div>

 

  </div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctDialogMapsList from "@/components/appgui/ctDialogMapsList.vue";

export default {
    i18n,
    data: () => ({
		markers: [],
		startCenter: {lat:43.773348, lng:11.255971},
		siteSelectedObj: null,
		options: {}
		/*
		options: {
			styles: [
				{
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#212121"
					}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
					{
						"visibility": "off"
					}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#757575"
					}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
					{
						"color": "#212121"
					}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#757575"
					}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#9e9e9e"
					}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"stylers": [
					{
						"visibility": "off"
					}
					]
				},
				{
					"featureType": "administrative.locality",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#bdbdbd"
					}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#757575"
					}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#181818"
					}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#616161"
					}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.stroke",
					"stylers": [
					{
						"color": "#1b1b1b"
					}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry.fill",
					"stylers": [
					{
						"color": "#2c2c2c"
					}
					]
				},
				{
					"featureType": "road",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#8a8a8a"
					}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#373737"
					}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#3c3c3c"
					}
					]
				},
				{
					"featureType": "road.highway.controlled_access",
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#4e4e4e"
					}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#616161"
					}
					]
				},
				{
					"featureType": "transit",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#757575"
					}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
					{
						"color": "#000000"
					}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
					{
						"color": "#3d3d3d"
					}
					]
				}
			]
		}
		*/	
    }),
    props: ['orgid', 'sitesList'],
    components: {
      'ct-maps-list': ctDialogMapsList,
    },
    methods: {
      initGoogleMapSites(sitesList) 
      {
        var appBasePath = this.$router.options.base;
		var markerBasePath = appBasePath + 'markers/';
		
        for (var i = 0; i < sitesList.length; i++) 
        {
          var siteObj = sitesList[i];
          if (!this.isEmptyObj(siteObj)) 
          {
            //=== CREAZIONE DEL MARKER
            this.markers[i] = [];
            this.markers[i]['position'] = {lat: siteObj.site_location.latitude, lng: siteObj.site_location.longitude};
            this.markers[i]['siteObj'] = siteObj;
			this.startCenter.lat = siteObj.site_location.latitude
			this.startCenter.lng = siteObj.site_location.longitude

			//http://maps.google.com/mapfiles/ms/icons/green-dot.png
			//url: '/appguinew/markers/marker_alert.png',
			//url: '/appguinew/markers/marker_ok.png',
			
			if(siteObj.alert == true)
			{
				this.markers[i]['icon'] =  {
					url: markerBasePath +'marker_alert.png',
					size: { width: 40, height: 40, f: "px", b: "px" },
					scaledSize: { width: 40, height: 40, f: "px", b: "px" }
				}
			} 
			else 
			{
				this.markers[i]['icon'] =  {
					url: markerBasePath +'marker_ok.png',
					size: { width: 40, height: 40, f: "px", b: "px" },
					scaledSize: { width: 40, height: 40, f: "px", b: "px" }
				}
			}
			
          }	
        }	
      },
      doSelectSite(siteObj) 
      {
        //console.log("Click su Marker");
        this.siteSelectedObj = siteObj;
        this.$refs.dialogMapsList.openDialogMapList(this.orgid, siteObj);
      },
		setGoogleCenterBySite(siteObj) 
		{
			this.startCenter.lat = siteObj.site_location.latitude;
			this.startCenter.lng = siteObj.site_location.longitude;
		}
    }
};
</script>